import React from "react";
import { Menu, MenuItem } from "@mui/material";

const TelecallerMenu = ({ anchorEl, open, onClose, users, onSelect }) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "10px",
          mt: 1,
          minWidth: 160,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          border: "1px solid #E5E7EB",
        },
      }}
    >
      {users.map((user) => (
        <MenuItem
          key={user}
          onClick={() => onSelect(user)}
          sx={{
            fontSize: 13,
            color: user === "Unassigned" ? "#9CA3AF" : "#374151",
            "&:hover": {
              bgcolor: "#F8FAFC",
            },
          }}
        >
          {user}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default TelecallerMenu;
